var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buzz-the-man-the-myth-the-legend",class:[_vm.medMax ? 'med-max' : '', _vm.animateBuzz ? 'animate-buzz' : '', _vm.buzzClass],on:{"click":function($event){return _vm.buzzWasClicked()}}})}
var staticRenderFns = []

export { render, staticRenderFns }